import { render, staticRenderFns } from "./DiscussionsConfigurationSection.vue?vue&type=template&id=cc7899b6&scoped=true"
import script from "./DiscussionsConfigurationSection.vue?vue&type=script&lang=js"
export * from "./DiscussionsConfigurationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7899b6",
  null
  
)

export default component.exports